import { Icon, Headline2, Body2 } from "@bms-ai/bms-ai-ui-lib/components";

export default function NotFound() {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            color: "#BE2BBB",
            gap: "1.25rem"
        }}>
            <Icon type="question" size="large" />
            <Headline2
                className="font-bms font-bold"
                style={{
                    marginTop: "1rem",
                    fontSize: "2.5rem"
                }}
            >
                Oops! You Don't Have Access
            </Headline2>
            <Body2
                className="font-bms font-normal"
                style={{
                    marginTop: "0.5rem",
                    fontSize: "1.2rem",
                    color: "#444",
                    textAlign: "center",
                    maxWidth: "600px"
                }}
            >
                It looks like this page isn't available to you. But don't worry, we can get you back on track!
            </Body2>
            <a
                href={import.meta.env.VITE_REDIRECT_URL}
                className="font-bms"
                style={{
                    marginTop: "1rem",
                    fontSize: "1.1rem",
                    color: "#BE2BBB",
                    textDecoration: "underline",
                    cursor: "pointer"
                }}
            >
                Take Me Home
            </a>
        </div>
    );
}
